import { Link, LinkProps, useMatch } from 'react-router-dom';

import { IconButton, IconButtonProps } from './icon-button';

export function IconButtonLink(props: IconButtonProps & LinkProps) {
  const match = useMatch(props.to.toString());
  return <IconButton variant='text' selected={Boolean(match)} component={Link} {...props} />;
}
